// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate.
  *
  */

import React from 'react';

import { ReactComponent as LogoComponent } from './Logo.svg';

import Icon, { TIconProps } from '../Icon';

export const IconLogo = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <LogoComponent/>
  </Icon>
));
